import { GuidDataFieldInterface } from '../..';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoicePortalSearchRequestResponseModel extends BaseContainerModel {
        single_general_pool_guid: GuidDataFieldInterface;
        individual_pool_guid: GuidDataFieldInterface;
        request_status: string;
        submission_status: string;
        validation_status: string;
        submission_date: Date;
        batch_pool_hdr_guid: GuidDataFieldInterface;
        validation_date: Date;
        to_irb_hdr_guid: GuidDataFieldInterface;
        amount_txn: number;
        date_txn: Date;
        pin_no: string;
        server_doc_1: string;
        server_doc_2: string;
        server_doc_3: string;
        client_doc_1: string;
        client_doc_2: string;
        client_doc_3: string;
        client_doc_4: string;
        client_doc_5: string;
        einvoice_submission_type: string;
        generic_doc_hdr_guid: GuidDataFieldInterface;
        doc_ccy: string;
}
